import React from "react"
import { BrowserRouter as Router, Routes, Route, Outlet } from "react-router-dom"
import { AuthProvider } from "./contexts/AuthContext"
import ProtectedRoute from "./components/admin/ProtectedRoute"
import AdminLogin from "./pages/admin/AdminLogin"
import AdminRoles from "./pages/admin/AdminRoles"
import AdminUsers from "./pages/admin/AdminUsers"
import AdminPages from "./pages/admin/AdminPages"
import AdminArchive from "./pages/admin/AdminArchive"
import AdminVerses from "./pages/admin/AdminVerses"
import AdminSchedule from "./pages/admin/AdminSchedule"
import { Footer } from "./components/footer/Footer"
import { Header } from "./components/header/Header"
import { Login } from "./pages/login/Login"
import { Account } from "./pages/account/Account"
import { WebArchive } from "./pages/archive/WebArchive"
import { Create } from "./components/create/Create"
import { Contact } from "./pages/common/Contact"
import { Schedule } from "./pages/common/Schedule"
import { About } from "./pages/common/About"
import { HotNews } from "./pages/common/HotNews"
import { Help } from "./pages/common/Help"
import { home_folder, oldChurchSite } from "./assets/data/constants"
import { append } from "./components/i18n/i18n"
import { ThemeProvider } from "./contexts/ThemeContext"
import YoutubeNews from "./components/blog/YoutubeNews"
import InstaFeed from "./components/blog/InstaFeed"
import { NewsFeed } from "./pages/common/NewsFeed"
import { Resources } from "./pages/resources/Resources"
import { Bible } from "./pages/bible/Bible"
import { Article1PastoralVocation } from "./pages/resources/Article1PastoralVocation"
import { Article2TheGodsWill } from "./pages/resources/Article2TheGodsWill"
import { Article3Nehemiah } from "./pages/resources/Article3Nehemiah"
import { Article4Resilience } from "./pages/resources/Article4Resilience"
import { Article5WhoWeAre } from "./pages/resources/Article5WhoWeAre"
import { Article6OnThePriesthood } from "./pages/resources/Article6OnThePriesthood"
import { Article7FaithfulMessage } from "./pages/resources/Article7FaithfulMessage"
import { Article8IHaveADream } from "./pages/resources/Article8IHaveADream"
import { Article9KingMilestones } from "./pages/resources/Article9KingMilestones"
import { Article10EnduringLife } from "./pages/resources/Article10EnduringLife"

const PublicLayout = () => (
  <>
    <Header />
    <Outlet />
    <Footer />
  </>
)

const App = () => {
  let locale = localStorage.getItem('userLanguage')
  if (!locale) locale = 'ua'
  append(require(`./localization/${locale}.json`))

  return (
    <ThemeProvider>
    <AuthProvider>
      <Router basename={`${home_folder}`}>
        <Routes>
          {/* Admin section — no Header/Footer */}
          <Route path='/admin/login' element={<AdminLogin />} />
          <Route path='/admin/roles' element={
            <ProtectedRoute permission='admin:roles'><AdminRoles /></ProtectedRoute>
          } />
          <Route path='/admin/users' element={
            <ProtectedRoute permission='admin:users'><AdminUsers /></ProtectedRoute>
          } />
          <Route path='/admin/pages' element={
            <ProtectedRoute permission='admin:pages'><AdminPages /></ProtectedRoute>
          } />
          <Route path='/admin/archive' element={
            <ProtectedRoute permission='admin:archive'><AdminArchive /></ProtectedRoute>
          } />
          <Route path='/admin/schedule' element={
            <ProtectedRoute permission='admin:schedule'><AdminSchedule /></ProtectedRoute>
          } />
          <Route path='/admin/verses' element={
            <ProtectedRoute permission='admin:pages'><AdminVerses /></ProtectedRoute>
          } />
          <Route path='/admin' element={
            <ProtectedRoute><AdminPages /></ProtectedRoute>
          } />

          {/* Public site — wrapped with Header + Footer */}
          <Route element={<PublicLayout />}>
            <Route exact path='/' element={<HotNews />} />
            <Route path='/news/:id' element={<YoutubeNews />} />
            <Route exact path='/login' element={<Login />} />
            <Route exact path='/insta' element={<InstaFeed />} />
            <Route exact path='/account' element={<Account />} />
            <Route exact path='/create' element={<Create />} />
            <Route exact path='/contact' element={<Contact />} />
            <Route exact path='/about' element={<About />} />
            <Route exact path='/help' element={<Help />} />
            <Route exact path='/archive' element={<WebArchive />} />
            <Route exact path='/schedule' element={<Schedule />} />
            <Route exact path='/newsfeed' element={<NewsFeed />} />
            <Route exact path='/resources' element={<Resources />} />
            <Route exact path='/bible' element={<Bible />} />
            <Route exact path='/resources/pastoral-vocation' element={<Article1PastoralVocation />} />
            <Route exact path='/resources/the-gods-will' element={<Article2TheGodsWill />} />
            <Route exact path='/resources/nehemiah-formation' element={<Article3Nehemiah />} />
            <Route exact path='/resources/4-resilience' element={<Article4Resilience />} />
            <Route exact path='/resources/5-whoweare' element={<Article5WhoWeAre />} />
            <Route exact path='/resources/6-priesthood' element={<Article6OnThePriesthood />} />
            <Route exact path='/resources/7-faithful-message' element={<Article7FaithfulMessage />} />
            <Route exact path='/resources/8-i-have-a-dream' element={<Article8IHaveADream />} />
            <Route exact path='/resources/9-path-milestones-king' element={<Article9KingMilestones />} />
            <Route exact path='/resources/10-enduring-life' element={<Article10EnduringLife />} />
            <Route exact path='/oldsite' element={() => {
              window.location.href = oldChurchSite
              return null
            }} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
    </ThemeProvider>
  )
}

export default App
